import {LicenceStatus} from "../../constants/LicenceStatus";
import React from "react";
import KeyOutlined from "@ant-design/icons/es/icons/KeyOutlined";
import FileTextTwoTone from "@ant-design/icons/es/icons/FileTextTwoTone";
import FileMarkdownOutlined from "@ant-design/icons/es/icons/FileMarkdownOutlined";
import FileMarkdownTwoTone from "@ant-design/icons/es/icons/FileMarkdownTwoTone";
import LockOutlined from "@ant-design/icons/es/icons/LockOutlined";
import LockTwoTone from "@ant-design/icons/es/icons/LockTwoTone";
import MailOutlined from "@ant-design/icons/es/icons/MailOutlined";
import MailTwoTone from "@ant-design/icons/es/icons/MailTwoTone";
import DeleteOutlined from "@ant-design/icons/es/icons/DeleteOutlined";
import DeleteTwoTone from "@ant-design/icons/es/icons/DeleteTwoTone";
import StopOutlined from "@ant-design/icons/es/icons/StopOutlined";
import StopTwoTone from "@ant-design/icons/es/icons/StopTwoTone";
import GridActionIcon from "../../components/GridActionIcon";
import InfoCircleOutlined from "@ant-design/icons/es/icons/InfoCircleOutlined";
import InfoCircleTwoTone from "@ant-design/icons/es/icons/InfoCircleTwoTone";
import MessageOutlined from "@ant-design/icons/es/icons/MessageOutlined";
import MessageTwoTone from "@ant-design/icons/es/icons/MessageTwoTone";
import ContainerTwoTone from "@ant-design/icons/es/icons/ContainerTwoTone";
import ContainerOutlined from "@ant-design/icons/es/icons/ContainerOutlined";

const ICON_DISABLED_COLOR = 'lightgray';

const getActionsItems = ({
                             record, onRevokeClick, onDeleteClick, onLicenceSend, onSendPassword,
                             onLicenceDownload, showLicenceInfo, onPublicKeyDownload, twoToneColor,
                             onSendOfflineValidationTokenViaSms, onSendOfflineValidationTokenViaEmail,
                             licenceDetailsVisible, toggleLicenceDetails
                         }, useButtonInsteadOfIcon) => {

    const revokeDisabled = record.status !== LicenceStatus.ACTIVE,
        deleteDisabled = record.status !== LicenceStatus.REVOKED && record.status !== LicenceStatus.EXPIRED,
        sendLicenceDisabled = record.status !== LicenceStatus.ACTIVE,
        sendSmsDisabled = record.status !== LicenceStatus.ACTIVE,
        sendEmailDisabled = record.status !== LicenceStatus.ACTIVE,
        sendPasswordDisabled = record.status !== LicenceStatus.ACTIVE,
        downloadDisabled = record.status !== LicenceStatus.ACTIVE,
        downloadPublicKeyDisabled = false;

    const actionsItems = [];

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="revoke"
                                      title='Revoke'
                                      disabled={revokeDisabled}
                                      icon={<StopTwoTone
                                          twoToneColor={revokeDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<StopOutlined/>}
                                      onClick={() => onRevokeClick(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="delete"
                                      title='Delete'
                                      disabled={deleteDisabled}
                                      icon={<DeleteTwoTone
                                          twoToneColor={deleteDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<DeleteOutlined/>}
                                      onClick={() => onDeleteClick(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="sendLicence"
                                      title='Send Licence'
                                      disabled={sendLicenceDisabled}
                                      icon={<MailTwoTone
                                          twoToneColor={sendLicenceDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<MailOutlined/>}
                                      onClick={() => onLicenceSend(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="sendSms"
                                      title='Send Validation Token - SMS'
                                      disabled={sendSmsDisabled}
                                      icon={<MessageTwoTone
                                          twoToneColor={sendSmsDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<MessageOutlined/>}
                                      onClick={() => onSendOfflineValidationTokenViaSms(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="sendEmail"
                                      title='Send Validation Token - Email'
                                      disabled={sendEmailDisabled}
                                      icon={<ContainerTwoTone
                                          twoToneColor={sendEmailDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<ContainerOutlined/>}
                                      onClick={() => onSendOfflineValidationTokenViaEmail(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="sendPassword"
                                      title='Send Password'
                                      disabled={sendPasswordDisabled}
                                      icon={<LockTwoTone
                                          twoToneColor={sendPasswordDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<LockOutlined/>}
                                      onClick={() => onSendPassword(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="download"
                                      title='Download Licence'
                                      disabled={downloadDisabled}
                                      icon={<FileMarkdownTwoTone
                                          twoToneColor={downloadDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<FileMarkdownOutlined/>}
                                      onClick={() => onLicenceDownload(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="publicKey"
                                      title='Download Public Key'
                                      disabled={downloadPublicKeyDisabled}
                                      icon={<FileTextTwoTone
                                          twoToneColor={downloadPublicKeyDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<KeyOutlined/>}
                                      onClick={() => onPublicKeyDownload(record)}/>);

    actionsItems.push(<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon}
                                      key="licenceContent"
                                      title='Licence Content'
                                      icon={<InfoCircleTwoTone
                                          twoToneColor={downloadPublicKeyDisabled ? ICON_DISABLED_COLOR : twoToneColor}/>}
                                      darkIcon={<InfoCircleOutlined/>}
                                      onClick={() => showLicenceInfo(record)}/>);

    return actionsItems;

};

const getDetailsIcon = ({record, licenceDetailsVisible, toggleLicenceDetails, twoToneColor}, useButtonInsteadOfIcon) => {

    return [<GridActionIcon useButtonInsteadOfIcon={useButtonInsteadOfIcon} key="details" title="Details"
                            icon={<InfoCircleTwoTone twoToneColor={twoToneColor}/>}
                            darkIcon={<InfoCircleOutlined/>}
                            onClick={() => {
                                toggleLicenceDetails(!licenceDetailsVisible, record)
                            }}/>]
};

export {getDetailsIcon}

export default getActionsItems;